import { render, staticRenderFns } from "./ItemTableLayout.vue?vue&type=template&id=37024c27&scoped=true&"
var script = {}
import style0 from "./ItemTableLayout.vue?vue&type=style&index=0&id=37024c27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37024c27",
  null
  
)

export default component.exports